module.exports = __webpack_public_path__ + "img/trust-down1.00c3ee4a.png";